export default __webpack_public_path__ + "static/media/basemap1.9173937f.jpg";